<template>
<div v-if="props.settings && props.settings.heading" style="font-weight:500;font-size:20px;margin-bottom:10px;margin-top:10px;margin-left:15px;">{{ props.settings.heading }}</div>
<DxHtmlEditor :element-attr="{ style: 'height: 100%;' }" styling-mode="outlined" @value-changed="onValueChanged" ref="editorComponent" v-if="props.preview && isUsingRichtextEditor">
	<DxToolbar :multiline="true">
		<DxItem name="insertTable" />
		<DxItem name="deleteTable" />
		<DxItem name="variable" />
		<DxItem name="separator" />
		<DxItem name="decreaseIndent" />
		<DxItem name="increaseIndent" />
		<DxItem name="separator" />
		<DxItem name="bold" />
		<DxItem name="italic" />
		<DxItem name="strike" />
		<DxItem name="underline" />
		<DxItem name="separator" />
		<DxItem name="color" />
		<DxItem name="background" />
		<DxItem name="separator" />
		<DxItem name="header" :accepted-values="headerValues" />
		<DxItem name="size" :accepted-values="sizeValues" />
		<DxItem name="font" :accepted-values="fontValues" />
		<DxItem name="separator" />
		<DxItem name="undo" />
		<DxItem name="redo" />
		<DxItem name="separator" />
		<DxItem name="alignLeft" />
		<DxItem name="alignCenter" />
		<DxItem name="alignRight" />
		<DxItem name="alignJustify" />
		<DxItem name="separator" />
		<DxItem name="orderedList" />
		<DxItem name="bulletList" />
		<DxItem name="separator" />
		<DxItem name="link" />
		<DxItem name="image" />
		<DxItem name="separator" />
		<DxItem name="clear" />
		<DxItem name="codeBlock" />
		<DxItem name="blockquote" />
		<DxItem name="separator" />
	</DxToolbar>
	<DxVariables :data-source="editorVariables" :escape-char="editorEscapes" />
	<DxTableContextMenu :enabled="true" />
	<DxTableResizing :enabled="true" />
</DxHtmlEditor>
<div v-else-if="props.preview" style="height:100%;width:100%;">
	<iframe sandbox="" :srcdoc="renderedHtml" style="width: 100%; height: 100%; border: none;"></iframe>
</div>
<div v-else-if="!props.preview && isUsingRichtextEditor" class="ux-html-render" v-html="renderedHtml"></div>
<div v-else-if="!props.preview && !isUsingRichtextEditor" style="height:100%;width:100%;"><iframe sandbox="" :srcdoc="renderedHtml" style="width: 100%; height: 100%; border: none;"></iframe></div>
</template>

<style>
.ux-html-render {
	white-space: pre;
}
</style>

<script setup>
/* eslint-disable */
import { DxHtmlEditor, DxToolbar, DxItem, DxVariables, DxTableContextMenu, DxTableResizing } from 'devextreme-vue/html-editor';
import { defineProps, defineEmits, ref, computed, watch, nextTick } from 'vue';

const props = defineProps([
	'preview',
	'settings',
	'context'
]);
const emit = defineEmits(['previewOptionsChanged']);
const editorComponent = ref(null);

const isUsingRichtextEditor = computed(() => {
	return props.settings.htmlMode != 'full';
});

const renderedMoteValues = computed(() => {
	return props.context && props.context.hasValidContext() ? props.context.context.moteValues() : null;
});

const htmlVals = ref('');
const renderedHtml = computed(() => {
	console.log("Rendered HTML", htmlVals.value);
	if (!htmlVals.value) {
		return '';
	}

	let ret = htmlVals.value;
	if (renderedMoteValues.value) {
		for (const key in renderedMoteValues.value) {
			ret = ret.replaceAll(`{${key}}`, renderedMoteValues.value[key]);
		}
	}
	
	if (props.settings.htmlMode == 'full') {
		ret = `<!DOCTYPE html><html><body>${ret}</body></html>`;
	}
	
	return ret;
});

const sizeValues = ['8pt', '10pt', '12pt', '14pt', '18pt', '24pt', '36pt'];
const fontValues = ['Arial', 'Georgia', 'Tahoma', 'Times New Roman', 'Verdana'];
const headerValues = [false, 1, 2, 3, 4, 5];

const editorVariables = computed(() => {
	if (!props.context || !props.context.shouldUseContext())
		return [];
	let possibleSchemas = props.context.getContextSchemas();
	if (possibleSchemas.length == 0) {
		// TODO: Should we allow for all schemas here?
		return [];
	}
	let fields = possibleSchemas.map(schema => schema.fields).flat();
	let fieldNames = fields.map(field => field.field);
	return [...new Set(fieldNames)];
});
const editorEscapes = ['{', '}'];

const ignoreNextValueChange = ref(false);			// Ignore initial value change event when we set from our prop watcher.
const onValueChanged = (e) => {
	if (ignoreNextValueChange.value) {
		ignoreNextValueChange.value = false;
		return;
	}
	htmlVals.value = e.value;
	// The parent component is responsible for persisting changes to HTML content changes (which is not done until user triggers the component save).
	emit('previewOptionsChanged', htmlVals.value);
};

// Watch changes to our props to update HTML contents.
watch(props, async () => {
	console.log("Props updated", props.settings);
	let initialValue = '';
	if (props && props.settings) {
		if (props.settings.htmlMode == 'full' && props.settings.htmlRawContent) {
			initialValue = props.settings.htmlRawContent;
		} else if (props.settings.htmlMode == 'simple' && props.settings.content) {
			initialValue = props.settings.content;
		}
	}
	htmlVals.value = initialValue;

	if (props.preview) {
		nextTick(() => {
			ignoreNextValueChange.value = true;
			if (isUsingRichtextEditor.value && editorComponent.value && editorComponent.value.instance) {
				editorComponent.value.instance.reset(initialValue);
			}
		});
	}
}, {
	immediate: true
});

</script>
